export const NEGATIVE_SIGN = '-';
export const DECIMAL_DOT = '.';
